<app-example-wrapper-seamless sectionHeading="Tax Slabs">
    <div class="row">
        <div class="col-xl-12">
            <div class="card card-box mb-5">
                <div class="card-body">
                    <div class="d-flex justify-content-between pb-3">
                        <div class="search-wrapper">
                            <span class="icon-wrapper text-black">
                                <fa-icon [icon]="['fas', 'search']"></fa-icon>
                            </span>
                            <input type="text" class="form-control form-control-sm rounded-pill" pqlaceholder="Search..." [ngModelOptions]="{standalone: true}" [(ngModel)]="searchText">
                        </div>
                        <div>
                            <button class="btn btn-sm btn-primary" type="button" (click)="addTaxService()"
                                id="addTeamMember">
                                <span class="btn-wrapper--icon">
                                    <fa-icon [icon]="['fas', 'plus']" class="opacity-8 font-size-xs" class="text-white">
                                    </fa-icon>
                                </span>
                                <span class="btn-wrapper--label">
                                    Add Tax
                                </span>
                            </button>
                            <button (click)="getData()" tooltip="Refresh" id="reloadEmployees"
                                class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                type="button">
                                <span class="btn-wrapper--icon">
                                    <i class="ion-md-sync"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="allTaxServices | tsearch:searchText; let filteredTax"> 
                        <div class="table-responsive table-scroll">
                            <table class="table table-hover table-striped table-bordered text-nowrap mb-3"  [mfData]="filteredTax" #mf="mfDataTable" [mfRowsOnPage]="100"
                            [mfActivePage]="activePage"> 
                                <thead>
                                    <tr>
                                        <th class="bg-white text-left"> Station </th>
                                        <th class="bg-white text-left"> Tax Slab </th>
                                        <th class="bg-white text-left"> Tax Label </th>
                                        <th class="bg-white text-left">Tax Label Description</th>
                                        <!-- <th class="bg-white text-left">Status</th> -->
                                        <th class="bg-white text-left">&nbsp;</th>
                                    </tr>
                                </thead> <tbody>
                                    <tr *ngFor="let tservice of mf.data; let i = index">
                                        <td class="text-left">{{tservice.STATION}}</td>
                                        <td class="text-left">{{tservice.TAX_SLAB}}</td>
                                        <td class="text-left">{{tservice.TAX_LABEL}}</td>
                                        <td class="text-left">{{tservice.TAX_LABEL_DESCRIPTION}}</td>
                                        <!-- <td class="text-left">
                                            <span class="badge bg-neutral-dark text-success"
                                            *ngIf="tservice.ACTIVE==true">Active</span>
                                            <span class="badge bg-neutral-dark text-warning"
                                            *ngIf="tservice.ACTIVE==false">Inactive</span>
                                        </td> -->
                                        <td class="text-left">
                                            <button class="btn btn-sm btn-neutral-dark" tooltip="Edit" type="button"
                                                (click)="editTaxService(tservice)">
                                                <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="6"> 
                                            <span class="font-weight-bold text-primary">Total Tax Services: {{filteredTax.length}}
                                                </span>
                                            &nbsp;&nbsp;&nbsp;
                                            <mfBootstrapPaginator [rowsOnPageSet]="[200,400,600,800,1000]">
                                            </mfBootstrapPaginator>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-example-wrapper-seamless>
<notifier-container></notifier-container>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>

